import { render, staticRenderFns } from "./ShopCart.vue?vue&type=template&id=bd3c3a30&scoped=true&"
import script from "./ShopCart.vue?vue&type=script&lang=js&"
export * from "./ShopCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3c3a30",
  null
  
)

export default component.exports